<template>
  <div @click="dialog = true" :style="styles" class="grid-item">
    <SliderModal
      :prevId="prevId"
      :nextId="nextId"
      :id="item.id"
      name="article"
      scrollToElement
      v-model="dialog"
    >
      <Memory :memory="item" />
    </SliderModal>
    <div class="grid-item__logo">
      <div
        class="grid-item__logo-inner"
        :style="
          item.logo_urls
            ? { backgroundImage: `url(${item.logo_urls.large})` }
            : {}
        "
      ></div>
    </div>
    <div class="grid-item__bg"></div>

    <div
      class="grid-item__image"
      :style="
        item.preview_urls
          ? { backgroundImage: `url(${item.preview_urls.large})` }
          : {}
      "
    >
      <div class="grid-item__image__contents">
        {{ item.short_description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GridItem",
  props: {
    item: Object,
    prevId: Number,
    nextId: Number,
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped lang="scss">
.grid-item::v-deep .v-responsive__content {
  position: relative;
  z-index: 1;
}

.grid-item {
  display: flex;
  align-items: flex-end;
  padding: 20px;
  cursor: pointer;
  background-size: cover;
  background-position-x: center;
  background-position-y: 25%;
  position: relative;

  &.with-background:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(26, 26, 26, 0) 0%,
      rgba(26, 26, 26, 0.85) 100%
    );
  }

  &:hover {
    filter: brightness(105%);
  }

  &__footer {
    display: flex;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  &__author {
    color: #ffffff;
  }

  &__page {
    color: #b1b3b3;
    margin-left: 10px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.grid-item {
  flex-basis: calc(50% - 16px);
  border-radius: 10px;
  margin-bottom: 33px;
  flex-direction: column;
  padding: 0;
  align-items: stretch;
  &__image {
    font-family: "Roboto Condensed", sans-serif;
    font-size: 16px;
    line-height: 1;
    font-weight: 700;
    margin-bottom: 0.35em;
    border-radius: 0px 0px 10px 10px;
    box-shadow: 0px -1px 19px 4px rgba(0, 0, 0, 0.13);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 100%;
      padding-bottom: 25.7vw;
    }
    &__contents {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 30px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      color: white;
    }
  }

  &__logo {
    box-shadow: 0px -1px 19px 4px rgba(0, 0, 0, 0.13);
    border-radius: 10px 10px 0px 0px;
    position: relative;
    z-index: 1;
    background: white;
    &::before {
      content: "";
      display: block;
      width: 100%;
      height: 10vw;
    }
    &-inner {
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      position: absolute;
      top: 10%;
      left: 17px;
      right: 17px;
      bottom: 10%;
    }
  }
}

@media screen and (max-width: 960px) {
  .grid-item {
    flex-basis: 100%;

    &__logo::before {
      height: 206px;
    }
    &__image {
      &::before {
        padding-bottom: 549px;
      }
      &__contents {
        padding: 10px;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
